import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      &:after {\n        display: block;\n        ", "\n        ", "\n        ", "\n        ", "\n        ", "\n        content: '';\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  transition: box-shadow 0.3s ease-in-out;\n  background-color: ", ";\n  box-shadow: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  \n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { SENSATION_WHITE } from '../colors';
import { SHADOW_ALARM, SHADOW_ALARM_FOCUSED, SHADOW_DEFAULT, SHADOW_FOCUSED, SHADOW_PRIMARY, SHADOW_PRIMARY_FOCUSED, SHADOW_WARNING, SHADOW_WARNING_FOCUSED, SUPER_SHADOW } from '../shadows';
import { CARD_BORDER_RADIUS_EXTRA_LARGE, CARD_BORDER_RADIUS_LARGE, CARD_BORDER_RADIUS_MEDIUM, CARD_BORDER_RADIUS_SMALL } from '../constants';
import { borderShadowMixin } from './border';
import { fullSizeAbsoluteStyle } from '../tokens/full-size';
import { overflowHiddenStyle, overflowStyle } from '../tokens/overflow';
import { userSelectNoneStyle } from '../tokens/user-select';
import { pointerEventsNoneStyle } from '../tokens/pointer-events';
import { backgroundClipStyle } from '../tokens/background';
import { styleFlagForBreakpoints } from '../helpers/media-style';
import { borderRadius } from '../style/border-radius';
var BORDER_RADIUS = {
  small: CARD_BORDER_RADIUS_SMALL,
  medium: CARD_BORDER_RADIUS_MEDIUM,
  large: CARD_BORDER_RADIUS_LARGE,
  'extra-large': CARD_BORDER_RADIUS_EXTRA_LARGE
};
var SHADOW = {
  default: SHADOW_DEFAULT,
  primary: SHADOW_PRIMARY,
  alarm: SHADOW_ALARM,
  warning: SHADOW_WARNING
};
var SHADOW_FOCUS = {
  default: SHADOW_FOCUSED,
  primary: SHADOW_PRIMARY_FOCUSED,
  alarm: SHADOW_ALARM_FOCUSED,
  warning: SHADOW_WARNING_FOCUSED
};
export var cardMixin = css(_templateObject(), function (_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? SENSATION_WHITE : _ref$backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var _ref2$shadowVariant = _ref2.shadowVariant,
      shadowVariant = _ref2$shadowVariant === void 0 ? 'default' : _ref2$shadowVariant;
  return SHADOW[shadowVariant] || SHADOW.default;
}, function (_ref3) {
  var withFocusShadow = _ref3.withFocusShadow,
      _ref3$shadowVariant = _ref3.shadowVariant,
      shadowVariant = _ref3$shadowVariant === void 0 ? 'default' : _ref3$shadowVariant;
  return styleFlagForBreakpoints(withFocusShadow, "box-shadow: " + (SHADOW_FOCUS[shadowVariant] || SHADOW_FOCUS.default) + ";");
}, function (_ref4) {
  var withSuperShadow = _ref4.withSuperShadow;
  return styleFlagForBreakpoints(withSuperShadow, "box-shadow: " + SUPER_SHADOW + ";");
}, function (_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 'small' : _ref5$size;
  return borderRadius(BORDER_RADIUS[size] || BORDER_RADIUS.small);
}, overflowStyle, function (_ref6) {
  var withHover = _ref6.withHover,
      hasTouch = _ref6.hasTouch,
      _ref6$shadowVariant = _ref6.shadowVariant,
      shadowVariant = _ref6$shadowVariant === void 0 ? 'default' : _ref6$shadowVariant;
  return withHover && !hasTouch && "\n    &:hover {\n      box-shadow: " + (SHADOW_FOCUS[shadowVariant] || SHADOW_FOCUS.default) + ";\n    }\n  ";
}, function (_ref7) {
  var withUserSelectNone = _ref7.withUserSelectNone;
  return withUserSelectNone && userSelectNoneStyle;
}, function (_ref8) {
  var withOverflowHidden = _ref8.withOverflowHidden;
  return withOverflowHidden && "\n    position: relative;\n    overflow: hidden;\n  ";
}, function (_ref9) {
  var withBackgroundClip = _ref9.withBackgroundClip;
  return withBackgroundClip && "\n    " + overflowHiddenStyle + "\n    " + backgroundClipStyle + "\n  ";
}, function (_ref10) {
  var borderColor = _ref10.borderColor,
      _ref10$size = _ref10.size,
      size = _ref10$size === void 0 ? 'small' : _ref10$size;
  return borderColor && css(_templateObject2(), fullSizeAbsoluteStyle, borderRadius(BORDER_RADIUS[size] || BORDER_RADIUS.small), borderShadowMixin, userSelectNoneStyle, pointerEventsNoneStyle);
}, function (_ref11) {
  var as = _ref11.as,
      forwardedAs = _ref11.forwardedAs,
      onClick = _ref11.onClick,
      inactive = _ref11.inactive,
      disabled = _ref11.disabled,
      clickable = _ref11.clickable,
      noFocus = _ref11.noFocus,
      _ref11$shadowVariant = _ref11.shadowVariant,
      shadowVariant = _ref11$shadowVariant === void 0 ? 'default' : _ref11$shadowVariant;
  return (onClick || clickable || as === 'button' || forwardedAs === 'button') && !inactive && !disabled && !noFocus && "\n    &:focus {\n      box-shadow: " + (SHADOW_FOCUS[shadowVariant] || SHADOW_FOCUS.default) + ";\n    }\n  ";
}, function (_ref12) {
  var as = _ref12.as,
      forwardedAs = _ref12.forwardedAs,
      inactive = _ref12.inactive,
      disabled = _ref12.disabled,
      noFocus = _ref12.noFocus,
      _ref12$shadowVariant = _ref12.shadowVariant,
      shadowVariant = _ref12$shadowVariant === void 0 ? 'default' : _ref12$shadowVariant;
  return (as === 'label' || forwardedAs === 'label') && !inactive && !disabled && !noFocus && "\n    &:focus-within {\n      box-shadow: " + (SHADOW_FOCUS[shadowVariant] || SHADOW_FOCUS.default) + ";\n    }\n  ";
});
export var cardKeys = ['withSuperShadow', 'withFocusShadow', 'withOverflowHidden', 'withBackgroundClip', 'withHover', 'withUserSelectNone', 'size', 'shadowVariant', 'borderColor', 'backgroundColor'];